import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-add-rule-destination',
  templateUrl: './add-rule-destination.component.html',
  styleUrls: ['./add-rule-destination.component.scss']
})
export class AddRuleDestinationComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AddRuleDestinationComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private cdr: ChangeDetectorRef
    ) { }


    comboAtendentes = [{value: 'Diretores'}, {value: 'Superintendentes'}, {value: 'Corretores', selected: true}];
    combosList = [
      {
        status: 1,
        value: 'Deve conter',
        type: true,
        color: 'green'
      },
      {
        status: 2,
        value: 'Não deve conter',
        type: false,
        color: 'red'
      }
    ];
    allowOfflineCombo = [{id: 1, value: 'Sim'}, {id: 2, value: 'Não'}];

    form = {
      company: '',
      rule: {...this.combosList[0], ...{isOpen: false}},
      offline: this.allowOfflineCombo[1],
      percentage: '',
      answer: [],
      channel: []
    };
    autocomplete = [];
  ngOnInit(): void {
    this.cdr.detectChanges();
  }

  closeAddNewLine() {
    this.dialogRef.close();
  }

  setRuleCombo(item) {
    this.form.rule = item;
  }

  setAtendentes(event) {
    this.form.answer = event;
  }

  setChannel(event) {
    this.form.channel = event;
  }

  addNewLine() {
    this.dialogRef.close(this.form);
  }
  searchElement(event) {
    this.autocomplete = [{description: 'aaaaa', type: 'bbbb'}, {description: 'ccccccccccc', type: 'ssssss'}];
  }

  setElement(event) {
    this.form.company = event;
  }

}
